import GoogletagFacade from '../googletagFacade/GoogletagFacade'
import Logger from '../helpers/Logger'
import WebModel from '../models/WebModel'
import { s2sBidder } from '../enums/Bidder'

export const LIFT_TEST_PERCENT = 0.04 // 4 percent

const adXPartners = ['rubicon', 'pubmatic', 'openx', 'indexExchange']

/**
 * This module performs tests to determine the lift of each bidder.
 * There is a 4% chance that a test will be performed.  If a test is performed
 * we pick at random from a list of tests which include valid bidders for the
 * site we are on, AdExchange bidders, and disabling both prebid AND Adx for a particular bidder.
 * Then there is a 50/50 chance that this run will be a control or a test run.
 * If we are not the control, we disable the bidder associated with the test.
 */
export default class LiftTest {
  constructor(model: WebModel, googletagFacade: GoogletagFacade) {
    const randomNumber = Math.random()
    const s2sBidders = Object.keys(s2sBidder).map((bidder) => {
      return { name: bidder }
    })

    if (randomNumber <= LIFT_TEST_PERCENT) {
      const potentialTests = [
        ...model.bidders,
        ...s2sBidders,
        { name: 'eb' }, // Exchange Bidding
        // Options for Partners that also bid in Exchange Bidding...
        ...model.bidders
          .filter((bidder) => adXPartners.indexOf(bidder.name) !== -1)
          .reduce((myArray: Array<{ name: string }>, bidder) => {
            // Option to disable bidder in Exchange Bidding.
            myArray.push({ name: `${bidder.name}_eb` })
            // Option to disable partner in both Prebid and Exchange Bidding.
            myArray.push({ name: `${bidder.name}_both` })

            return myArray
          }, [])
      ]

      // pick a random bidder to test.
      const randomIndex = Math.floor(Math.random() * potentialTests.length)
      const randomTest = potentialTests[randomIndex]
      const shortBidderName = randomTest.name

      let liftValue
      /* eslint-disable-next-line no-magic-numbers */
      if (Math.random() <= 0.5) {
        liftValue = `${shortBidderName}_0`

        // Need to disable prebid if shortBidderName ends in _both.
        // Filtering names that end in _eb won't do anything, as intended.
        const bidderName = shortBidderName.replace('_both', '')

        // Remove the bidder from each adDefinition's prebid list so we don't request bids from them
        Object.keys(model.bidRequests).forEach((adunit) => {
          model.bidRequests[adunit] = model.bidRequests[adunit].filter(
            (bid) => bid.bidder !== bidderName
          )
        })

        Logger.debug(
          `BIDDER: ${randomTest.name} (${shortBidderName}) turned OFF`
        )
      } else {
        // This is the control.  Everything proceeds as normal.
        liftValue = `${shortBidderName}_1`
      }

      GoogletagFacade.onReady<void>(() => {
        googletagFacade.pubads.setTargeting('partnerLift', liftValue)
      })
    }
  }
}
